import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import MainTheme from './mainTheme';
// import otherTheme from './otherTheme';

export default function DefaultProps({children}) {
  return (
    <ThemeProvider theme={MainTheme}>
      {children}
    </ThemeProvider>
  );
}
